// extracted by mini-css-extract-plugin
export default {"theme-color":"#af5d50","theme-color-2":"#404bbd","primary":"#404bbd","desaturate-color":"#d3d3d3"};